/**
 * Прилет жетона при размещении: жетон падает на ячейку сверху, проявляясь и
 * уменьшаясь до своего размера, и в момент касания земли зовется onLand — там
 * звук постройки и клубы пыли (см. HexGridRenderer.showBuildingDropAnimation
 * и configs/buildingDropAnimation).
 *
 * Главное обязательство этого модуля: onLand зовется РОВНО ОДИН РАЗ в любом
 * случае. Нет поля, не загрузилась текстура, старый рендерер, ячейки нет на
 * экране — жетон «садится» сразу, и звук с пылью не пропадают.
 *
 * @param {Object} store
 * @param {Object} hexGridRenderer
 * @param {string} hexKey
 * @param {Object} params
 * @param {string} [params.tokenType] — обычный жетон
 * @param {string} [params.specialBuildingType] — спецстроение
 * @param {boolean} [params.isPlanned] — жетон из плана строительства (в hexes
 *   его нет): полет прячет только спрайт плана и живет, пока запись в плане
 * @param {Function} [params.onLand] — приземление жетона
 * @param {{kind: string, palette: Object}} [params.impact] — какой удар у постройки
 *   (см. scenes/playBuildingImpactEffects)
 */
export const playBuildingDropAnimation = (store, hexGridRenderer, hexKey, {
  tokenType,
  specialBuildingType,
  isStartingQuarter,
  isPlanned = false,
  onLand,
  impact,
} = {}) => {
  const land = () => onLand?.();

  if (!hexGridRenderer || !hexKey || (!tokenType && !specialBuildingType)
    || typeof hexGridRenderer.showBuildingDropAnimation !== 'function') {
    land();
    return;
  }

  let started = false;
  try {
    started = hexGridRenderer.showBuildingDropAnimation(hexKey, {
      tokenType,
      specialBuildingType,
      isStartingQuarter,
      isPlanned,
      state: store.getState(),
      onLand: land,
      impact,
    });
  } catch (error) {
    // Анимация — украшение: ее поломка не должна съесть звук постройки
    console.warn('[Drop] не удалось показать прилет жетона', error);
    started = false;
  }

  if (!started) {
    land();
  }
};
